import type { IntlShape } from 'react-intl';
import { PITCH_MAX_WORDS, PITCH_MIN_WORDS } from 'fym-shared/src/music24/outreach/pitchRules';
import { reviewMessages as messages } from './reviewMessages';

/** The `pitchLint` hints that block Approve until the text is fixed (design outreach f1 note). */
export const BLOCKING_HINTS: ReadonlySet<string> = new Set(['mentionsMoney', 'missingPitchLink']);

export interface HintLine {
  key: string;
  text: string;
  blocks: boolean;
}

/** The lines of the lint hints and the P7 problems of one pitch. Unknown hints are dropped. */
export function hintLines(intl: IntlShape, lintHints: string[], qualityProblems: string[]): HintLine[] {
  const lines = lintHints.flatMap((hint): HintLine[] => {
    switch (hint) {
      case 'tooShort':
        return [
          { key: hint, text: intl.formatMessage(messages.hintTooShort, { min: PITCH_MIN_WORDS }), blocks: false },
        ];
      case 'tooLong':
        return [{ key: hint, text: intl.formatMessage(messages.hintTooLong, { max: PITCH_MAX_WORDS }), blocks: false }];
      case 'tooManyLinks':
        return [{ key: hint, text: intl.formatMessage(messages.hintTooManyLinks), blocks: false }];
      case 'mentionsMoney':
        return [{ key: hint, text: intl.formatMessage(messages.hintMoney), blocks: true }];
      case 'missingPitchLink':
        return [{ key: hint, text: intl.formatMessage(messages.hintMissingLink), blocks: true }];
      default:
        return [];
    }
  });
  return [
    ...lines,
    ...qualityProblems.map((problem) => ({
      key: `q-${problem}`,
      text: intl.formatMessage(messages.hintQuality, { problem }),
      blocks: false,
    })),
  ];
}

/** The word count of a pitch body (the footer and the pitch link count too, as the server does). */
export function wordCount(body: string): number {
  return body.split(/\s+/).filter((word) => word !== '').length;
}
